import { translate } from "app/filters/i18nFilter";
import type { FieldItem } from "app/pages/sales-intelligence/modules/enrichment/store/type";
import type { ConfigField, CsvExportColumnType } from "app/pages/sales-intelligence/modules/enrichment/types/columns";
import { columnKeys } from "app/pages/sales-intelligence/utils/i18n/columns";

const createConfigField = (column: CsvExportColumnType): ConfigField => ({
    name: column.name,
    alias: column.id,
    type: column.type,
});

export const exportColumnAdapters = {
    createColumnFieldAdapter: (column: CsvExportColumnType, exampleValue: string | undefined): FieldItem => ({
        id: column.id,
        field: createConfigField(column),
        label: column.columnPickerName ?? translate(columnKeys.title(column.name)),
        additionalLabel: column.additionalLabel ?? exampleValue,
    }),

    createDynamicColumnFieldAdapter: (column: CsvExportColumnType, exampleValue: string | undefined) => ({
        ...exportColumnAdapters.createColumnFieldAdapter(column, exampleValue),
        label: column.columnPickerName ?? column.name,
    }),
};
